/** Where a Super Admin lands after exiting an impersonation session. */
const SUPER_ADMIN_RETURN_ROUTE = '/admin/companies';

/**
 * Impersonation is reached by opening a company, so returning from a session
 * drops the Super Admin back on the companies list rather than a dedicated
 * impersonation page.
 */
export function getDefaultImpersonationRoute(): string {
  return SUPER_ADMIN_RETURN_ROUTE;
}
